import { MenuItem, MenuList, Popover } from '@mui/material';
import { useNavigate } from 'react-router';
import LogoutIcon from '@mui/icons-material/Logout';
import { useDispatch } from 'react-redux';

import styles from '../../../assets/styles/accountPopover';
import CustomTypography from '../../Typography/typography';
import { authSliceActions } from '../../../redux/slice/authSlice';

const AccountPopover = (props: any) => {
  const { anchorEl, onClose, open } = props;
  const classes = styles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleSignOut = () => {
    dispatch(authSliceActions.signout());
    navigate('/');
  };

  return (
    <>
      {' '}
      <Popover
        anchorEl={anchorEl}
        anchorOrigin={{
          horizontal: 'left',
          vertical: 'bottom',
        }}
        onClose={onClose}
        open={open}
        PaperProps={{ sx: { width: 150 } }}
      >
        <MenuList disablePadding dense className={classes.menulist}>
          <MenuItem onClick={handleSignOut}>
            <CustomTypography className={classes.typography}>
              <LogoutIcon fontSize='small' /> Sign out
            </CustomTypography>
          </MenuItem>
        </MenuList>
      </Popover>
    </>
  );
};

export default AccountPopover;
